<template>
    <div class="section">
        <div class="container p-0">
            <h2 class="title col-12">Porftolio de consultoria de serviços em nuvem<label>.</label></h2>

            <div class="col-12 row m-0 p-0">  
                <div class="col-12 col-lg-6 portolio-item p-2">
                    <div class="portolio-wrapper row m-0">
                        <div class="col-12 col-lg-3 p-0">
                            <img src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/port-adoption.png" />
                        </div>
                        <div class="col-12 col-lg-9">
                            <h5>Programa de Adoção Cloud </h5>
                            <h6>
                                O programa de adoção cloud consiste em uma consultoria 
                                que auxilia no inicio de uma operação cloud de 
                                sucesso.
                            </h6>
                        </div>
                    </div>
                </div>  
                
                <div class="col-12 col-lg-6 portolio-item p-2">
                    <div class="portolio-wrapper row m-0">
                        <div class="col-12 col-lg-3 p-0">
                            <img src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/port-continuous.png" />
                        </div>
                        <div class="col-12 col-lg-9">
                            <h5>Gerenciamento Contínuo</h5>
                            <h6>Conte com a Cloud CT para monitoramento, 
                                manutenções preventivas, boas práticas e 
                                migrações.</h6>
                        </div>
                    </div>
                </div> 

                <div class="col-12 col-lg-6 portolio-item p-2">
                    <div class="portolio-wrapper row m-0">
                        <div class="col-12 col-lg-3 p-0">
                            <img src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/port-cost.png" />
                        </div>
                        <div class="col-12 col-lg-9">
                            <h5>Plano de Redução de Custos</h5>
                            <h6>Utilize os recursos de forma correta e sustentável. 
                                Com o plano de redução é possível até 50% de economia.
                            </h6>
                        </div>
                    </div>
                </div> 

                <div class="col-12 col-lg-6 portolio-item p-2">
                    <div class="portolio-wrapper row m-0">
                        <div class="col-12 col-lg-3 p-0">
                            <img src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/port-architecture.png" />
                        </div>
                        <div class="col-12 col-lg-9">
                            <h5>Projeto de Arquitetura Cloud</h5>
                            <h6>Aplicamos os recursos de nuvem que o seu
                                projeto precisa, sempre pensando no sucesso 
                                do seu cliente.
                            </h6>
                        </div>
                    </div>
                </div> 

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'portfolio-section'
}
</script>

<style scoped lang="scss">

.portolio-item {
    

    .portolio-wrapper {
        border: 1px solid #7ed6df;
        transition: border 0.5s;
        border-radius: 4px;
        border-bottom-right-radius: 20px;
        border-top-left-radius: 20px;

        img {
            width: 100%;
            border-bottom-left-radius: 4px;
            border-top-left-radius: 20px;
        }
    }

    .portolio-wrapper:hover {
        border: 1px solid #22a6b3;
    }

    
}

</style>
